/* This is supposed to come from an api finally */
export const appSettings = {
  config: {
    mode: process.env.MODE || 'development',
  },
  authentication: {
    loggedIn: false, // Set this to false to implement login
  },
  client: {
    name: '', // 'sss',
    displayName: '', // 'Social Sports Security',
    logoPath: '', // 'https://socialsportssociety.com/wp-content/uploads/2022/07/SocialSportSociety-logo-1.svg',
    tenantId: '',
  },
  api: {
    GRAPHQL: process.env.NEXT_PUBLIC_GRAPHQL, // 'https://dev1.bldr.it/graphql',
    PROXY: process.env.NEXT_PUBLIC_PROXY, // 'https://d58upws4l1.execute-api.eu-west-1.amazonaws.com',
    ASSET_MANAGER_URL: process.env.NEXT_PUBLIC_ASSET_MANGER_URL,
    MEMBERSHIP_URL: process.env.NEXT_PUBLIC_MEMBERSHIP_URL,
    PAYMENT_URL: process.env.NEXT_PUBLIC_PAYMENT_URL,
    ORDER_MANAGER_URL: process.env.NEXT_PUBLIC_ORDER_MANAGER_URL,
    LLM_SERVICE_URL: process.env.NEXT_PUBLIC_LLM_SERVICE_URL,
    DSPY_API_URL: process.env.NEXT_PUBLIC_DSPY_API_URL,
    DEFAULT_PARTNER_VENDOR_ID: process.env.NEXT_PUBLIC_DEFAULT_PARTNER_VENDOR_ID,
    S3_MEDIA: process.env.NEXT_PUBLIC_S3_MEDIA,
    S3_MEDIA_COMPRESSED: process.env.NEXT_PUBLIC_S3_MEDIA_COMPRESSED,
    OPEN_ID_COGNITO_URL: process.env.NEXT_PUBLIC_OPEN_ID_COGNITO_URL,
    OPEN_ID_COGNITO_IDENTITY_PROVIDER: process.env.NEXT_PUBLIC_OPEN_ID_COGNITO_IDENTITY_PROVIDER,
    OPEN_ID_COGNITO_CALLBACK_PATH: process.env.NEXT_PUBLIC_OPEN_ID_COGNITO_CALLBACK_PATH,
    OPEN_ID_COGNITO_LOGOUT_PATH: process.env.NEXT_PUBLIC_OPEN_ID_COGNITO_LOGOUT_PATH,
    CLIENT_APP_URL: process.env.NEXT_PUBLIC_CLIENT_APP_URL,
    SSO_SECRET_KEY: process.env.NEXT_PUBLIC_SSO_SECRET_KEY,
    VIPS_CALLBACK_URL: process.env.NEXT_PUBLIC_VIPS_CALLBACK_URL,
    OPEN_ID_COGNITO_CLIENT_ID: process.env.NEXT_PUBLIC_OPEN_ID_COGNITO_CLIENT_ID,
    API_QR_CODE_URL: process.env.NEXT_PUBLIC_API_QR_CODE,
    API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_PATH,
    GOOGLECAPTCHASITEKEY: process.env.NEXT_PUBLIC_GOOGLECAPTCHASITEKEY,
    S3_MULTIPLEMEDIA: process.env.NEXT_PUBLIC_S3UPLOADMULTIPLEIMAGE,
    S3_FILEMEDIA: process.env.NEXT_PUBLIC_S3UPLOADFILE,
    LOONSHOT_RESTAPI_URL: process.env.NEXT_PUBLIC_LOONSHOT_RESTAPI_URL,
    // Used by survey Places Autocomplete (SurveyPlacePicker). Enable Places API
    // (Autocomplete + Details/Geocoding) on this key; restrict by HTTP referrer in GCP.
    GOOGLE_MAP_APIKEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    VIDEO_URL: process.env.NEXT_PUBLIC_VIDEO_URL,
    EMAIL_INVITE_URL: process.env.NEXT_PUBLIC_EMAIL_INVITE_URL,
    WS_URL: process.env.NEXT_PUBLIC_WS_URL,
    EVENT_MANAGER_URL: process.env.NEXT_PUBLIC_EVENT_MANAGER_URL,
    ANALYTICS: process.env.NEXT_PUBLIC_ANALYTICS,
    BOLDER_STICKER_MASTER_USERID: process.env.BOLDER_STICKER_MASTER_USERID,
    EMAIL_TEMPLATE_CREATE: process.env.NEXT_PUBLIC_EMAIL_TEMPLATE_CREATE,
    EMAIL_TEMPLATE_SEND: process.env.NEXT_PUBLIC_EMAIL_TEMPLATE_SEND,
    EMAIL_TEMPLATE_FETCH: process.env.NEXT_PUBLIC_EMAIL_TEMPLATE_FETCH,
    CREATE_CONNECT_BUTTONS: process.env.NEXT_PUBLIC_CREATE_CONNECT_BUTTONS,
    DEV_FALLBACK_HOST: process.env.NEXT_PUBLIC_DEV_FALLBACK_HOST,
    EMAIL_ATTACHMENTS_URL: process.env.NEXT_PUBLIC_EMAIL_ATTACHMENTS_URL,
  },
  images: {
    Avatar: '/images/icons/avatar.jpg',
    DropDownArrowLight: '/images/icons/Path 4369_down_arrow_light.svg',
    HorizontalDots: '/images/icons/horizontal_dots.svg',
    DropDownArrowDark: '/images/icons/Path 4055_down_arrow_dark.svg',
    CheckedInIcon: '/images/icons/icon-action-check_circle.svg',
    QrIcon: '/images/icons/qrcode.svg',
    QrCode: '/images/icons/qrcode.svg',
    CloseIcon: '/images/icons/ic_close.svg',
    ShareIcon: '/images/icons/icon-social-share.svg',
    CopyIcon: '/images/icons/copy-icon.svg',
    VippsLogo: '/images/logos/vipps-logo.svg',
    VippsPayLogo: '/images/logos/vipps_pay.png',
    QR_PLACEHOLDER: '/images/logos/qrcode_placeholder.png',
    BolderLogo: '/images/logos/bolder_black.png',
    BolderIcon: '/images/logos/bolder_icon.png',
    ColorTheme: '/images/icons/colortheme.svg',
    Vipps: '/images/logos/vippsIcon.svg',
    PartnerLogo: '/images/productShareIcons/cooperation.png',
    ProductLogo: '/images/productShareIcons/box.png',
    fulfulled: 'images/icons/fulfilled.png',
    VippsWhiteLogo: '/images/logos/vippsWhiteIcon.svg',
  },
  view: {
    indicators: {},
    selected: null,
    inEditMode: false,
  },
  data: {
    listingQuery: { type: '', date: null, label: 'data' },
  },
};
